<template>
  <ManagerWrapper v-slot="{ managers, holdings, loading, holdingsFinished, holdLoadMore }">
    <ManagerList :data="managers" class="section-margin">
      <MoreTitle title="公司高管" />
    </ManagerList>
    <ManagerHoldingList
      v-if="market !== 'hs'"
      :data="holdings"
      :loading="loading"
      :finished="holdingsFinished"
      :loadMore="holdLoadMore"
      class="section-margin"
    >
      <MoreTitle title="高管持股变动" />
    </ManagerHoldingList>
  </ManagerWrapper>
</template>

<script>
import ManagerWrapper from '@/components/f10/manager/ManagerWrapper.vue'
import ManagerList from '@/components/f10/manager/ManagerList.vue'
import ManagerHoldingList from '@/components/f10/manager/ManagerHoldingList'
import { sendMsg } from "@/plugins/msg";
import ManagerHoldingTimeline from "@/components/f10/manager/ManagerHoldingTimeline.vue";
export default {
  components: { ManagerHoldingTimeline, ManagerWrapper, ManagerList, ManagerHoldingList },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    }
  },
  created() {
    sendMsg({ event: 'setTitle', title: this.$t('公司高管') })
  }
}
</script>
